const EmailStatusTag = ({ data }) => {
    const { endTime, state } = data.delivery || {};
    let tagInfo = { className: '', text: 'No information.', icon: 'fas fa-question-circle' };

    if (state === 'STARTING') {
        tagInfo = { className: 'has-text-primary', text: `Generating reset link.`, icon: 'fas fa-redo' };
    }

    if (state === 'SUCCESS') {
        const withDate = endTime ? `on the ${new Date(endTime.seconds * 1_000).toUTCString()}` : '';
        tagInfo = { className: 'has-text-success', text: `Successfully sent ${withDate}.`, icon: 'fas fa-check-circle' };
    }

    if (state === 'ERROR') {
        tagInfo = { className: 'has-text-danger', text: 'Cannot reset.', icon: 'fas fa-times-circle' };
    }

    if (state === 'PENDING') {
        tagInfo = { className: 'has-text-link', text: 'Pending...', icon: 'fas fa-hourglass-half' };
    }

    if (state === 'PROCESSING') {
        tagInfo = { className: 'has-text-info', text: 'Sending...', icon: 'fas fa-paper-plane' };
    }

    return (
        <p>
            <small>
                <span className="icon-text">
                    <span className={`icon ${tagInfo.className}`}>
                        <i className={tagInfo.icon}></i>
                    </span>
                    <span>{tagInfo.text}</span>
                </span>
            </small>
        </p>
    );
}

export { EmailStatusTag };
